<!-- 期初记账列表 -->
<template>
    <div class='page_content'>
        <subComponents ref="showSelectData"></subComponents>
        <initBookkeepingAction ref="initBookkeepingAction"></initBookkeepingAction>
        <div class="page_content_top">
            <div class="page_content_top_line">
                <el-button type="primary" size="mini" @click="actionSet(buttonValue)" v-for="(buttonValue,buttonKey) in buttonList" :key="buttonKey">
                    {{buttonValue.jurName}}
                </el-button>
                <el-button type="primary" icon="el-icon-refresh" size="mini" @click="getDataList()">
                    刷新
                </el-button>
            </div>
            <div class="page_content_top_line">
                <el-form :inline="true" :model="getRequestData" class="demo-form-inline" size="mini">
                    <el-form-item label="期初类型">
                        <el-select v-model="getRequestData.beginType" placeholder="请选择">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="供应商" :value="0"></el-option>
                            <el-option label="客户" :value="1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="单位名称">
                        <el-input v-model.trim="getRequestData.unitName"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="mini" @click="searchData">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="page_content_center">
            <el-table stripe :data="returnData.list" height="100%" border style="width: 100%" highlight-current-row>
                <el-table-column prop="beginAccount" label="期初金额"></el-table-column>
                <el-table-column prop="coName" label="货主"></el-table-column>
                <el-table-column prop="salesName" label="我方业务员"></el-table-column>
                <el-table-column prop="beginType" label="类型">
                    <template slot-scope="scope">
                        {{scope.row.beginType == 0 ? '供应商' :'客户'}}
                    </template>
                </el-table-column>
                <el-table-column prop="unitName" label="单位名称"></el-table-column>
                <el-table-column prop="opposalesName" label="对方业务员"></el-table-column>
                <el-table-column prop="bemCreaterName" label="创建人"></el-table-column>
                <el-table-column prop="bemCreatetime" label="创建时间">
                    <template slot-scope="scope">
                        <div v-if="scope.row.bemCreatetime">
                            {{$common.getLocalTime(scope.row.bemCreatetime)}}
                        </div>
                    </template>
                </el-table-column>

            </el-table>
        </div>
        <div class="page_content_bottom">
            <el-pagination background @size-change="setDataPageSize" @current-change="setDataPageNumber" :current-page="getRequestData.page" :page-sizes="[30,50,100,500]" :page-size="30"
                           layout="total, sizes, prev, pager, next, jumper" :total="returnData.total">
            </el-pagination>
        </div>

    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import initBookkeepingAction from "@/components/initBookkeepingAction.vue";

export default {
    //import引入的组件需要注入到对象中才能使用
    components: { initBookkeepingAction },
    data() {
        //这里存放数据
        return {

            getRequestData: {
                beginType: "",
                unitName: "",
                page: 1,
                rows: 30,
                start: '',
                end: '',
            },
            returnData: {
                pages: 0,  // 总页数
                total: 0,  // 总条数
                pageNum: 0,  // 当前页数
                list: []
            },
            buttonList: [],
            selectedDataIndex: 0,
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
    },
    //方法集合
    methods: {

        // 动作集合
        actionSet(actionData) {
            switch (actionData.actionType) {
                case 0:
                    this.$refs.initBookkeepingAction.openBox(0, '')
                    break;
            }
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1
            this.getDataList()
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val
            this.getDataList()
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1
            this.getRequestData.rows = val
            this.getDataList()
        },


        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.getInitBookkeeping(this.getRequestData)
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list
                this.returnData.pages = responseData.result.pages
                this.returnData.total = responseData.result.total
                this.returnData.pageNum = responseData.result.pageNum
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },



        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getDataList()
        this.getButtonList()

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
